const login = {
    "LOGIN_ROW1":"Academia",
    "LOGIN_ROW2":"Națională",
    "LOGIN_ROW3":"de Șah",
    "LOGIN_COPYRIGHT":"Academia de Șah",
    "LOGIN_FORM_WELCOME":"Welcome!",
    "LOGIN_FORM_SELECT_METHOD":"Выберите один из способов входа",
    "LOGIN_FORM_PRIMARY_BUTTON_LABEL":"Войти",
    "LOGIN_FORM_FACEBOOK_BUTTON_LABEL":"Авторизироваться с помощью Facebook",
    "LOGIN_FORM_GOOGLE_BUTTON_LABEL":"Авторизироваться с помощью Google",
    "LOGIN_FORM_LOGIN_PLACEHOLDER":"Логин",
    "LOGIN_FORM_PASSWORD_PLACEHOLDER":"Пароль",
    "BTN_SIGNOUT":"Выйти из системы",
};
export default login